import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Container } from "../layout/Container";
import SectionHeaderRow from "../shared/SectionHeaderRow";
import StoreCard from "../cards/StoreCard";
import { cPath } from "../../constants";

const Section = styled.section`
  padding: 2rem 0;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const Chip = styled.button`
  padding: 0.5rem 1.25rem;
  border-radius: ${({ theme }) => theme.radius.full};
  font-size: 0.875rem;
  font-weight: 500;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  cursor: pointer;
  border: 1px solid
    ${({ $active, theme }) =>
      $active
        ? `hsl(${theme.colors.primary})`
        : `hsl(${theme.colors.border})`};
  background: ${({ $active, theme }) =>
    $active ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.card})`};
  color: ${({ $active, theme }) =>
    $active
      ? `hsl(${theme.colors.primaryForeground})`
      : `hsl(${theme.colors.foreground})`};
  &:hover {
    background: ${({ $active, theme }) =>
      $active ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.muted})`};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 1.5rem;
  @media (min-width: 640px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

export default function HomeCategoryBrowse({
  categories,
  selectedCategory,
  onSelectCategory,
  filteredStores,
}) {
  const { t } = useTranslation();
  const chips = categories?.length ? categories : [t("home.categoryBrowse.all")];

  return (
    <Section>
      <Container>
        <SectionHeaderRow
          title={t("home.categoryBrowse.title")}
          to={cPath("categories")}
          linkLabel={t("home.categoryBrowse.allCategories")}
          marginBottom="1.5rem"
        />
        <Chips>
          {chips.map((cat) => (
            <Chip
              key={cat}
              type="button"
              $active={selectedCategory === cat}
              onClick={() => onSelectCategory(cat)}
            >
              {cat}
            </Chip>
          ))}
        </Chips>
        {selectedCategory !== "All" && (
          <Grid>
            {filteredStores.map((store) => (
              <StoreCard key={store.id} store={store} />
            ))}
          </Grid>
        )}
      </Container>
    </Section>
  );
}
